import React from 'react';
import {
  Paper,
  Box,
  Typography,
  IconButton,
  Button,
  alpha,
  useTheme,
} from '@mui/material';
import { 
  MoreVert, 
  CalendarToday,
  Language 
} from '@mui/icons-material';

interface UpcomingEventsProps {
  upcomingEvents: any[];
}

const UpcomingEvents: React.FC<UpcomingEventsProps> = ({ upcomingEvents }) => {
  const theme = useTheme();

  const handleManageEvents = () => {
    window.location.href = '/admin/events';
  };

  return (
    <Paper
      sx={{ 
        p: 3, 
        borderRadius: 2,
        boxShadow: theme.shadows[3],
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" fontWeight={600}>
          Upcoming Events
        </Typography>
        <IconButton size="small">
          <MoreVert fontSize="small" />
        </IconButton>
      </Box>
      
      {upcomingEvents.length === 0 ? (
        <Typography sx={{ py: 2, textAlign: 'center', color: 'text.secondary' }}>
          No upcoming events available.
        </Typography>
      ) : (
        upcomingEvents.slice(0, 3).map((event, index) => (
          <Box 
            key={event.id} 
            sx={{ 
              mb: 2,
              p: 2,
              borderRadius: 1,
              bgcolor: alpha(theme.palette.primary.main, 0.04),
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <CalendarToday 
                fontSize="small" 
                sx={{ color: theme.palette.text.secondary, mr: 1 }} 
              />
              <Typography variant="body2" color="text.secondary">
                {new Date(event.date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric'
                })}
              </Typography>
            </Box>
            <Typography variant="subtitle1" fontWeight={500}>
              {event.title}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
              <Language 
                fontSize="small" 
                sx={{ color: theme.palette.text.secondary, mr: 1 }} 
              />
              <Typography variant="body2" color="text.secondary">
                {event.location || "Location TBD"}
              </Typography>
            </Box>
          </Box>
        ))
      )}
      
      <Button 
        fullWidth 
        variant="outlined"
        sx={{ mt: 1 }}
        onClick={handleManageEvents}
      >
        Manage Events
      </Button>
    </Paper>
  );
};

export default UpcomingEvents; 